import {
  FETCH_DRIVERS_DOCUMENTS_TYPES_DATA,
  FETCH_DRIVERS_DOCUMENTS_TYPES_SUCCESS,
  FETCH_DRIVERS_DOCUMENTS_TYPES_FAILURE,
} from "./actionTypes";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const driversDocumentsTypes = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DRIVERS_DOCUMENTS_TYPES_DATA:
      return { ...state, loading: true, error: null };
    case FETCH_DRIVERS_DOCUMENTS_TYPES_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_DRIVERS_DOCUMENTS_TYPES_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default driversDocumentsTypes;
